<div class="login-page w-screen h-screen flex flex-col items-center justify-center gap-8">
  <div class="flex flex-col items-center gap-4">
    <div class="login-logo-container">
      <dynamic-logo></dynamic-logo>
    </div>
  </div>
  <div>
    <p-button
      label="Login"
      styleClass="p-button-rounded text-xl px-8 py-3"
      [style]="{ 'font-size': '1.5rem' }"
      (click)="login()"
    ></p-button>
  </div>
</div>
